// src/components/portal/PartnerRecord.js — the partner's record: deals
// introduced, mandates engaged, names submitted and contacts in pipelines
// (the partner credit record, item 9). Mainly for the CRM's attribution, so
// it lives in portal Settings rather than on the dashboard (Travis, 10/28).
// Same data as the dashboard (GET /api/portal/dashboard).
import { usePortalDashboard } from '../../pages/portal/PortalDashboard'
import { nameTypeLabel } from '../../lib/nameTypes'

function Stat({ label, value, sub }) {
  return (
    <div style={{ border: '1px solid var(--border)', borderRadius: 6, padding: '10px 14px' }}>
      <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, marginTop: 2 }}>{value}</div>
      {sub && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>{sub}</div>}
    </div>
  )
}

export default function PartnerRecord() {
  const { data } = usePortalDashboard()
  const record = data?.record
  if (!record) return null
  const namesTotal = record.names_by_type.reduce((n, t) => n + t.total, 0)
  const namesApproved = record.names_by_type.reduce((n, t) => n + t.approved, 0)
  const deeper = ['In Diligence', 'In Documentation', 'Closed'].reduce((n, s) => n + (record.pipeline_by_stage[s] ?? 0), 0)

  return (
    <div className="card" style={{ marginTop: 24 }}>
      <h2 style={{ fontSize: 15, fontWeight: 600, marginBottom: 16, color: 'var(--text-primary)' }}>Your record</h2>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))', gap: 12 }}>
        <Stat label="Deals introduced" value={record.deals_introduced.length + record.deals_submitted.length}
          sub={record.deals_submitted.length ? `${record.deals_submitted.length} submitted in the portal` : null} />
        <Stat label="Mandates engaged" value={record.mandates_engaged} />
        <Stat label="Names submitted" value={namesTotal} sub={namesTotal ? `${namesApproved} approved` : null} />
        <Stat label="Contacts in pipelines" value={record.pipeline_total}
          sub={record.pipeline_total ? `${deeper} in diligence or later` : null} />
      </div>
      {(record.deals_introduced.length > 0 || record.deals_submitted.length > 0) && (
        <div style={{ marginTop: 14 }}>
          <div style={{ fontSize: 12, fontWeight: 600, color: 'var(--text-secondary)', marginBottom: 6 }}>Deals</div>
          {record.deals_introduced.map(d => (
            <div key={`m-${d.mandate_name}`} style={{ fontSize: 13, marginBottom: 4 }}>
              {d.mandate_name} <span className="badge badge-gray" style={{ fontSize: 10, marginLeft: 6 }}>{d.status}</span>
            </div>
          ))}
          {record.deals_submitted.map((d, i) => (
            <div key={`s-${i}`} style={{ fontSize: 13, marginBottom: 4 }}>
              {d.company_name}
              <span style={{ color: 'var(--text-muted)', fontSize: 12 }}> · {d.work_type}</span>
              <span className="badge badge-gray" style={{ fontSize: 10, marginLeft: 6 }}>{d.status}</span>
            </div>
          ))}
        </div>
      )}
      {record.names_by_type.length > 0 && (
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 12 }}>
          Names by type: {record.names_by_type.map(t => `${nameTypeLabel(t.name_type, true)} ${t.total}`).join(' · ')}
        </div>
      )}
    </div>
  )
}
